import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const {
  endpoints: {
    company: { brands: url },
  },
} = config

const getUrl = (brand) => url.replace(':idCompany', brand.company || brand.idCompany).replace(':idBrand', brand._id ? `?idBrand=${brand._id}` : '')

/**
 * Add a new brand to the company
 * @param {Object} brand
 */
const addBrand = (brand) => axios.post(getUrl(brand), { brand }, { headers: getHeaders(true) })

/**
 * Get one or all brands to the company
 * @param {Object} brand
 */
const getBrands = (brand = false) => axios.get(getUrl(brand), { headers: getHeaders(true) })

/**
 * Update one brand to the company
 * @param {Object} brand
 */
const updateBrand = (brand) => axios.put(getUrl(brand), { brand }, { headers: getHeaders(true) })

/**
 * Delete ine brand to the company
 * @param {Object} brand
 */
const deleteBrand = (brand) => axios.delete(getUrl(brand), { headers: getHeaders(true) })

export default { addBrand, getBrands, updateBrand, deleteBrand }
